export default __webpack_public_path__ + "static/bb-0761910a35039c8cc02f8aab3f9ec097.png";